import { render } from "./innerUserButtons.vue?vue&type=template&id=4751ce30&scoped=true"
import script from "./innerUserButtons.vue?vue&type=script&lang=js"
export * from "./innerUserButtons.vue?vue&type=script&lang=js"

import "./innerUserButtons.vue?vue&type=style&index=0&id=4751ce30&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-4751ce30"

export default script